import $ from 'jquery';

$(document).on('turbo:load', function() {
  console.log("LINKER LOADED!");

  $(".gen-link").click(function(e){
    e.preventDefault();
    var url = $(this).attr("href");

    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      success: function(response) {
        console.log(response.links);
        var elem = $('#linker-body')
        elem.val(response.links);
        $('.linker-modal').modal("show");
        elem.select();
        //setTimeout(function () { elem.select(); }, 5);
      },

      error: function(response) {
        console.error(response);
      }
    })
  });

  var toggled = false;

  function refreshUI() {
    if ($(".asset-cb:checked").length > 0) {
      $('#link-all-btn, #delete-all-btn').removeClass("disabled");
    } else {
      $('#link-all-btn, #delete-all-btn').addClass("disabled");
    }
  }

  $('.asset-cb').change(function(e){
    refreshUI();
  });

  refreshUI();

  $('#toggle-all-btn').click(function(e){
    console.log("TOGGLED!!")
    e.preventDefault();


    if ($(".asset-cb:checked").length == $(".asset-cb").length) {
      // all checked
      $(".asset-cb").prop("checked", false);
    } else {
      // not
      $(".asset-cb").prop("checked", true);
    }

    refreshUI();
  });

  $('#link-all-btn').click(function(e){
    e.preventDefault();

    $.ajax({
      url: "<%= link_all_assets_url %>?"+$(".asset-cb:checked").serialize(),
      type: "POST",
      dataType: "json",
      success: function(response) {
        var elem = $('#linker-body')
        elem.val(response.links);
        $('.linker-modal').modal("show");
        elem.select();
      },

      error: function(result) {
        $("form").submit();
      }
    })
  });

  $('#delete-all-btn').click(function(e){
    e.preventDefault();

    if (confirm("Are you sure you want to delete these assets?")){
      $.ajax({
        url: "<%= delete_all_assets_url %>?"+$(".asset-cb:checked").serialize(),
        type: "GET",
        dataType: "html",
        success: function(result) {
          $("form").submit();
        },

        error: function(result) {
          $("form").submit();
        }
      });
    }
  });
});
